// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"2f117307","680":"ee36a42d","760":"d8de50ac"}[chunkId] + ".js";
};